import {
  ArchiveBoxXMarkIcon,
  BookOpenIcon,
  CheckIcon,
  ClockIcon,
  HeartIcon,
} from '@heroicons/react/16/solid'
import { EnBookmarkType } from '@prisma/client'
import { memo } from 'react'

export const BookmarkIcon = memo(function BookmarkIcon(props: {
  type: EnBookmarkType
}) {
  switch (props.type) {
    case EnBookmarkType.ABANDONED:
      return <ArchiveBoxXMarkIcon className="w-4" />
    case EnBookmarkType.COMPLETED:
      return <CheckIcon className="w-4" />
    case EnBookmarkType.FAVORITE:
      return <HeartIcon className="w-4" />
    case EnBookmarkType.PLAN:
      return <ClockIcon className="w-4" />
    case EnBookmarkType.READ:
      return <BookOpenIcon className="w-4" />

    default: {
      return undefined
    }
  }
})
